/**
 * SECURITY: CredentialTrap is a honeypot for browser autofill engines.
 *
 * Browsers (especially Microsoft Edge, Chrome, and password manager
 * extensions) aggressively inject saved login credentials into the FIRST
 * username/password-shaped pair of fields they find inside a form, even
 * when those fields use autocomplete="off". By placing a hidden, valid
 * username+password pair at the very top of every non-auth form, the
 * browser fills the trap fields instead of real fields like a child's
 * emergency contact.
 *
 * Render this component immediately inside any non-auth <form>, <Dialog>
 * body, or settings panel that contains text/email/tel inputs. Never
 * render on /login, /signup, /forgot-password, or /reset-password.
 */
export function CredentialTrap() {
  return (
    <div
      aria-hidden="true"
      // Visually hidden but still in the DOM so the autofill engine sees it.
      // Using inline styles to guarantee no theme override removes the hiding.
      style={{
        position: "absolute",
        left: "-9999px",
        top: "-9999px",
        width: 0,
        height: 0,
        overflow: "hidden",
        opacity: 0,
        pointerEvents: "none",
      }}
    >
      <input
        type="text"
        name="username"
        tabIndex={-1}
        autoComplete="username"
        defaultValue=""
        readOnly
      />
      <input
        type="password"
        name="password"
        tabIndex={-1}
        autoComplete="current-password"
        defaultValue=""
        readOnly
      />
    </div>
  );
}
